<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Notizen</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null" />
          <option value="with">Mit Trashed</option>
          <option value="only">Nur Trashed</option>
        </select>
      </search-filter>
      <inertia-link class="btn-green" :href="route('notes.create')">
        <span>Erschaffen</span>
      </inertia-link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Kunde</th>
          <th class="px-6 pt-6 pb-4">Text</th>
        </tr>
        <tr v-for="note in notes.data" :key="note.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('notes.edit', note.id)" tabindex="-1">
              {{ note.first_name }} {{ note.last_name }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('notes.edit', note.id)" tabindex="-1">
              {{ note.content | stripHTML }}
            </inertia-link>
          </td>
        </tr>
        <tr v-if="notes.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">Keine Notiz gefunden.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="notes.links" />
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import mapValues from 'lodash/mapValues'
import pickBy from 'lodash/pickBy'
import throttle from 'lodash/throttle'

export default {
  metaInfo: { title: 'Notiz' },
  components: {
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    notes: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('notes'), pickBy(this.form), { preserveState: true })
      }, 100),
    },
  },

  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },

  filters: {
    stripHTML: function(string) {
      return string ? string.replace(/<\/?[^>]+>|&nbsp;/ig, ' ') : string
    },
  },

}
</script>
